import { useDeleteMutation, WorkspaceRoutine } from '@gripp/shared-logic';
import {
  Colors,
  ConfirmationOverlay,
  useSlideLayout,
} from '@gripp/shared-ui';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-native-paper';

type DeleteRoutineMenuItemProps = {
  onSelected: () => void;
  workspaceRoutine: WorkspaceRoutine;
};

export const DeleteRoutineButton = (props: DeleteRoutineMenuItemProps) => {
  const { t } = useTranslation();
  const { setColumnOverlay } = useSlideLayout();
  const { mutateAsync, isPending } = useDeleteMutation({
    modelName: 'WorkspaceRoutine',
    query: DELETE_ROUTINE,
  });

  const hideOverlay = () => setColumnOverlay(null);

  const handleDeleteConfirm = async () => {
    if (isPending) return;
    await mutateAsync(
      { input: { id: props.workspaceRoutine.id } },
      {
        onSuccess: () => {
          hideOverlay();
          props.onSelected();
        },
      }
    );
  };

  const handleDeletePress = () => {
    setColumnOverlay(
      <ConfirmationOverlay
        title={t('routines.menu.delete.item')}
        subtitle={t('routines.menu.delete.title')}
        confirmLabel={t('routines.menu.delete.item')}
        onConfirm={handleDeleteConfirm}
        cancelLabel={t('routines.menu.delete.cancel')}
        onCancel={hideOverlay}
      />
    );
  };

  return (
    <Button
      mode="text"
      style={{ width: 152 }}
      labelStyle={{
        fontSize: 16,
      }}
      textColor={Colors.red}
      onPress={handleDeletePress}
    >
      Delete Routine
    </Button>
  );
};

const DELETE_ROUTINE = `
  mutation DeleteWorkspaceRoutine($input: MutateWorkspaceRoutineInput!) {
    deleteWorkspaceRoutine(input: $input) {
      id
    }
  }
`;
